import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cssUrl'
})
export class CssUrlPipe implements PipeTransform {
  /**
   * Make an CSS url out of string path
   *
   * @param path: string
   * @return string
   */
  public transform(path: string): string {
    return path ? `url(${path})` : path;
  }
}
